import Select from "@/components/Select";
import React, { useMemo } from "react";
import { Comparator, comparatorDefs, SerializedCondition } from "../types";
import ReactSelect, { SingleValue } from "react-select";

export type CountryCondition = {
  country: string;
  comparator: Comparator;
};

// Common countries from MaxMind GeoIP2 database (English names)
// These match what MaxMind's response.Country.Name returns
const countryOptions: Record<string, string> = {
  "Argentina": "Argentina",
  "Australia": "Australia",
  "Austria": "Austria",
  "Bangladesh": "Bangladesh",
  "Belgium": "Belgium",
  "Brazil": "Brazil",
  "Canada": "Canada",
  "Chile": "Chile",
  "China": "China",
  "Czech Republic": "Czech Republic",
  "Denmark": "Denmark",
  "Egypt": "Egypt",
  "Finland": "Finland",
  "France": "France",
  "Germany": "Germany",
  "Greece": "Greece",
  "Hong Kong": "Hong Kong",
  "India": "India",
  "Indonesia": "Indonesia",
  "Ireland": "Ireland",
  "Israel": "Israel",
  "Italy": "Italy",
  "Japan": "Japan",
  "Kenya": "Kenya",
  "Malaysia": "Malaysia",
  "Mexico": "Mexico",
  "Netherlands": "Netherlands",
  "New Zealand": "New Zealand",
  "Nigeria": "Nigeria",
  "Norway": "Norway",
  "Pakistan": "Pakistan",
  "Philippines": "Philippines",
  "Poland": "Poland",
  "Portugal": "Portugal",
  "Russia": "Russia",
  "Saudi Arabia": "Saudi Arabia",
  "Singapore": "Singapore",
  "South Africa": "South Africa",
  "South Korea": "South Korea",
  "Spain": "Spain",
  "Sweden": "Sweden",
  "Switzerland": "Switzerland",
  "Taiwan": "Taiwan",
  "Thailand": "Thailand",
  "Turkey": "Turkey",
  "Ukraine": "Ukraine",
  "United Arab Emirates": "United Arab Emirates",
  "United Kingdom": "United Kingdom",
  "United States": "United States",
  "Vietnam": "Vietnam"
};

export function CountryEditor({
  condition,
  onUpdate
}: {
  condition: SerializedCondition;
  onUpdate: (condition: SerializedCondition) => void;
}) {
  const countryCondition = JSON.parse(
    condition.data || "{}"
  ) as CountryCondition;

  const countrySelectOptions = useMemo(() => {
    return Object.keys(countryOptions).map((key) => ({
      value: key,
      label: key
    }));
  }, []);

  const selectedCountry = useMemo(() => {
    if (!countryCondition.country) return null;
    return {
      value: countryCondition.country,
      label: countryCondition.country
    };
  }, [countryCondition.country]);

  function update(data: CountryCondition) {
    onUpdate({ ...condition, data: JSON.stringify(data) });
  }

  function updateCountry(
    selectedOption: SingleValue<{ label: string; value: string }>
  ) {
    update({
      ...countryCondition,
      country: selectedOption?.value || ""
    });
  }

  const validComparatorOptions: Record<string, string> = {
    equals: comparatorDefs.equals,
    notEquals: comparatorDefs.notEquals,
    contains: comparatorDefs.contains,
    notContains: comparatorDefs.notContains,
    exists: comparatorDefs.exists,
    notExists: comparatorDefs.notExists
  };

  return (
    <>
      <Select
        options={validComparatorOptions}
        value={countryCondition.comparator}
        onChange={(v) => update({ ...countryCondition, comparator: v })}
      />
      {countryCondition.comparator !== "exists" &&
        countryCondition.comparator !== "notExists" && (
          <ReactSelect
            name="country"
            options={countrySelectOptions}
            value={selectedCountry}
            className="basic-select w-full"
            classNamePrefix="select"
            onChange={(e) => updateCountry(e)}
            placeholder="Select country..."
            isClearable
          />
        )}
    </>
  );
}
